<app-page-header icon="shield" title="Permisos" subtitle="Gestión de permisos de acceso a funcionalidades del sistema"></app-page-header>

<app-spinner
    [show]="!flagLoaded"
    [type]="'fullscreen'"
    [size]="'large'"
    [color]="'#B1476A'"
    [trackColor]="'#4CA7C8'"
    [text]="'Cargando permisos...'"
    [showText]="true"
    [blurBackground]="true">
</app-spinner>

<div *ngIf="!flagLoaded" style="height: 100vh;"></div>

<div *ngIf="flagLoaded" class="seguridad-area seguridad-animate-in">
  <div class="container">
    <div class="barra-superior">
      <button mat-stroked-button class="btn-volver" (click)="volver()">
        <mat-icon>arrow_back</mat-icon> Volver
      </button>
    </div>

    <div class="perfil-selectors">
      <mat-form-field appearance="outline" class="selector-rol">
        <mat-label>Rol a editar</mat-label>
        <mat-select [(ngModel)]="selectedPerfil" (selectionChange)="seleccionarPerfil($event.value)">
          <mat-option *ngFor="let p of perfiles" [value]="p">
            {{ p.key }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="selector-copia">
        <mat-label>Copiar reglas de</mat-label>
        <mat-select [(ngModel)]="selectedCopyFrom" (selectionChange)="copiarReglas($event.value)">
          <mat-option *ngFor="let p of perfiles" [value]="p" [disabled]="p._id === selectedPerfil?._id">
            {{ p.key }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="menu-tree-wrapper">
      <div class="tree-header">
        <span class="tree-header__name">Menú</span>
        <span class="tree-header__route">Ruta</span>
        <span class="tree-header__level">Nivel</span>
      </div>

      <ng-template #arbolNodo let-nodes="nodes" let-indent="indent">
        <div *ngFor="let node of nodes" class="tree-node-group">
          <div class="tree-row" [style.paddingLeft.px]="indent">
            <mat-checkbox
              [checked]="isChecked(node)"
              [indeterminate]="isIndeterminate(node)"
              (change)="onCheck(node, $event.checked)"
              color="primary"
            ></mat-checkbox>

            <button *ngIf="node.children.length; else spacer" mat-icon-button class="tree-toggle-btn"
                    (click)="toggleExpand(node); $event.stopPropagation()">
              <mat-icon class="tree-toggle-icon">
                {{ node.expanded ? 'expand_more' : 'chevron_right' }}
              </mat-icon>
            </button>
            <ng-template #spacer>
              <span class="tree-leaf-indent"></span>
            </ng-template>

            <span class="tree-name">{{ node.name }}</span>
            <code class="tree-route">{{ node.redirectTo }}</code>
            <span class="tree-level">L{{ node.level }}</span>
          </div>

          <ng-container *ngIf="node.expanded && node.children.length">
            <ng-container *ngTemplateOutlet="arbolNodo; context: { nodes: node.children, indent: indent + 28 }">
            </ng-container>
          </ng-container>
        </div>
      </ng-template>

      <ng-container *ngTemplateOutlet="arbolNodo; context: { nodes: treeRoots, indent: 16 }">
      </ng-container>
    </div>

    <div class="barra-inferior">
      <button mat-stroked-button class="btn-limpiar" (click)="limpiarCambios()" [disabled]="!selectedPerfil">
        Limpiar cambios
      </button>
      <button mat-stroked-button class="btn-guardar" (click)="guardar()" [disabled]="!selectedPerfil">
        Guardar cambios
      </button>
    </div>
  </div>
</div>
